// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"76bd895d","170":"32979424","184":"d9161b38","202":"4344ac2f","355":"a83175fe","453":"a5ac09ab","471":"f7f81f56","511":"b30327b1","618":"b41afedd","751":"fcd5982f","776":"02f32ee9","790":"5bf74f21","973":"77d6916a"}[chunkId] + ".chunk.js";
};